import { object, string } from "yup"

export const authenticateFormSchema = object({
  email: string().lowercase().email().trim().required("This field is required"),
  password: string().min(8).required("This field is required")
})
